<!-- eslint-disable max-len -->
<template>
  <div>
    <h4>RIWAYAT SERTIFIKASI</h4>

    <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="openEditModal">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="$refs.modalCreate.show()">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
        </b-form>
      </div>
    </v-server-table>
    <jLoadingTable v-if="!load_first"/>

    <b-modal
      ref="modalCreate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data Sertifikasi</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.jenis.$error}">
            <label> Jenis Sertifikasi </label>
            <j-input
              v-model="$v.data_master.jenis.$model"
              placeholder="Jenis Sertifikasi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.no_sertifikasi.$error}">
            <label> Nomor Sertifikasi </label>
            <j-input
              v-model="$v.data_master.no_sertifikasi.$model"
              type="number"
              placeholder="Nomor Sertifikasi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tahun.$error}">
            <label> Tahun Sertifikasi </label>
            <j-input
              v-model="$v.data_master.tahun.$model"
              type="number"
              placeholder="Tahun Sertifikasi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.bidang_studi.$error}">
            <label> Bidang Studi </label>
            <j-input
              v-model="$v.data_master.bidang_studi.$model"
              placeholder="Bidang Studi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nrg.$error}">
            <label> NRG </label>
            <j-input
              v-model="$v.data_master.nrg.$model"
              type="number"
              placeholder="NRG"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.no_peserta.$error}">
            <label> Nomor Peserta </label>
            <j-input
              v-model="$v.data_master.no_peserta.$model"
              type="number"
              placeholder="Nomor Peserta"/>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn blue m__r--5"
          @click="saveData">
          Save
        </b-button>
        <b-button
          class="btn gray"
          @click="closeModalCreate">
          Cancel
        </b-button>
      </div>
    </b-modal>

    <b-modal
      ref="modalUpdate"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Update Data Sertifikasi</h2>
      <b-row>
        <b-col md="12">
          <b-form-group :class="{'error-input' : $v.data_master.jenis.$error}">
            <label> Jenis Sertifikasi </label>
            <j-input
              v-model="$v.data_master.jenis.$model"
              :disabled="readOnly"
              placeholder="Jenis Sertifikasi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.no_sertifikasi.$error}">
            <label> Nomor Sertifikasi </label>
            <j-input
              v-model="$v.data_master.no_sertifikasi.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Nomor Sertifikasi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.tahun.$error}">
            <label> Tahun Sertifikasi </label>
            <j-input
              v-model="$v.data_master.tahun.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Tahun Sertifikasi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.bidang_studi.$error}">
            <label> Bidang Studi </label>
            <j-input
              v-model="$v.data_master.bidang_studi.$model"
              :disabled="readOnly"
              placeholder="Bidang Studi"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.nrg.$error}">
            <label> NRG </label>
            <j-input
              v-model="$v.data_master.nrg.$model"
              :disabled="readOnly"
              type="number"
              placeholder="NRG"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.no_peserta.$error}">
            <label> Nomor Peserta </label>
            <j-input
              v-model="$v.data_master.no_peserta.$model"
              :disabled="readOnly"
              type="number"
              placeholder="Nomor Peserta"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-button
            v-if="!readOnly"
            class="btn red m__t--20"
            @click="deleteData">
            Delete
          </b-button>
        </b-col>
        <b-col md="6">
          <div class="float-to-right m__t--20">
            <b-button
              v-if="!readOnly"
              class="btn blue m__r--5"
              @click="updateData">
              Update
            </b-button>
            <b-button
              class="btn gray"
              @click="closeModalUpdate">
              Cancel
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions, mapState } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  // eslint-disable-next-line
  name: 'jSertifikasi',
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      load_first: false,
      data_table: [],
      selected_rows: [],
      columns: ['jenis', 'no_sertifikasi', 'tahun', 'bidang_studi', 'nrg', 'no_peserta'],
      options: {
        headings: {
          jenis: 'JENIS SERTIFIKASI',
          no_sertifikasi: 'NOMOR SERTIFIKASI',
          tahun: 'TAHUN SERTIFIKASI',
          bidang_studi: 'BIDANG STUDI',
          nrg: 'NRG',
          no_peserta: 'NOMOR PESERTA',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: ['jenis', 'no_sertifikasi', 'tahun', 'bidang_studi', 'nrg', 'no_peserta'],
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          return {
            id_pegawai: data.id_pegawai,
          };
        },
        requestFunction(data) {
          const getList = jApiKurikulum.getListSertifikasi(data);
          return getList.catch((e) => {
            this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },

      data_master: {
        id_pegawai: this.$route.params.id,
        jenis: '',
        tahun: null,
        no_sertifikasi: null,
        bidang_studi: '',
        nrg: null,
        no_peserta: null,
      },
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKurikulum', ['createSertifikasi', 'updateSertifikasi', 'deleteSertifikasi']),

    loading(val) {
      const a = val;
      a.id_pegawai = this.$route.params.id;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    closeModalCreate() {
      this.$refs.modalCreate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        jenis: '',
        tahun: null,
        no_sertifikasi: null,
        bidang_studi: '',
        nrg: null,
        no_peserta: null,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    closeModalUpdate() {
      this.$refs.modalUpdate.hide();
      this.data_master = {
        id_pegawai: this.$route.params.id,
        jenis: '',
        tahun: null,
        no_sertifikasi: null,
        bidang_studi: '',
        nrg: null,
        no_peserta: null,
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    openEditModal(param) {
      this.$refs.modalUpdate.show();
      this.data_master = {
        id: param.row.id,
        id_pegawai: param.row.id_pegawai,
        jenis: param.row.jenis,
        tahun: param.row.tahun,
        no_sertifikasi: param.row.no_sertifikasi,
        bidang_studi: param.row.bidang_studi,
        nrg: param.row.nrg,
        no_peserta: param.row.no_peserta,
      };
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.createSertifikasi(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalCreate();
            }, 1500);
          }
        });
      }
    },

    updateData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.updateSertifikasi(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$refs.tableServer.getData();
              this.closeModalUpdate();
            }, 1500);
          }
        });
      }
    },

    deleteData() {
      this.$swal({
        title: 'Delete Data',
        text: 'Are you sure want to delete this data?',
        showCancelButton: true,
        confirmButtonText: 'Delete',
      }).then((result) => {
        if (result.value) {
          const param = {
            id: this.data_master.id,
          };
          this.deleteSertifikasi(param).then((res) => {
            if (!res.data.error) {
              setTimeout(() => {
                this.$refs.tableServer.getData();
                this.closeModalUpdate();
              }, 1500);
            }
          });
        }
      });
    },
  },
  validations() {
    return {
      data_master: {
        jenis: { required },
        tahun: { required },
        no_sertifikasi: { required },
        bidang_studi: { required },
        nrg: { required },
        no_peserta: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/tab-component/jSertifikasi.vue